const angular = require('angular');
const moment = require('moment-timezone');
const app = angular.module('learn-directives');
/**
 * Defines the user workshop display component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userWorkshopDisplay', ['Application', 'MultiSessionWorkshops', function (Application, MultiSessionWorkshops) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        item: '@',
        type: '@'
      },
      template: require('../../templates/directives/user-workshop-display.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        var guessedTz = moment.tz.guess();

        self.goToWorkshop = function() {
          if (self.userWorkshop.workshop.type === 'multi_session_workshop_session') {
            MultiSessionWorkshops.findParent({subsubresource: self.userWorkshop.workshop._id}).$promise.then(parent => {
              Application.navigation.goTo('/view/multi-session-workshops/' + parent.id);
              return;
            })
          } else {
            Application.navigation.goTo('/view/workshops/' + self.userWorkshop.workshop._id);
          }
        };

        self.recordingOpts = {
          recordings: [],
          show: false,
          selected: 0,
          select: function(index) {
            if (self.recordingOpts.recordings[index] && self.recordingOpts.recordings[index].link) {
              self.recordingOpts.selected = index;
            }
          },
          parseRecordings: function(options) {
            self.recordingOpts.recordings = options.map(function(item) {
              item.recording_type = item.recording_type ? item.recording_type.replace(/_/g, " ") : '';
              return item;
            });

          }
        }

        self.dateFormat = function(location, type) {
          var instance = self.userWorkshop.workshop_instance;
          if (!instance.start_date) {
            return '';
          }
          if (location === 'top') {
            if (type === 'month') {
              return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('MMM');
            }
            if (type === 'day') {
              return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('D');
            }
          }
          if (location === 'mid-full') {
            if (type === 'date') {
              return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('MMM D, YYYY');
            }
            if (type === 'time') {
              if (!self.multiDate) {
                return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('h:mma') + ' - ' + moment(new Date(instance.end_date).valueOf()).tz(guessedTz).format('h:mma z');
              }
              return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('h:mma z') + ' to';
            }
          }
          if (location === 'mid-full-end') {
            if (type === 'date') {
              return moment(new Date(instance.end_date).valueOf()).tz(guessedTz).format('MMM D, YYYY');
            }
            if (type === 'time') {
              return moment(new Date(instance.end_date).valueOf()).tz(guessedTz).format('h:mma z');
            }
          }
        }

        self.initialize = function () {
          self.userWorkshop = JSON.parse($scope.item);
          self.multiDate = false;
          var start = moment(new Date(self.userWorkshop.workshop_instance.start_date).valueOf());
          var end = moment(new Date(self.userWorkshop.workshop_instance.end_date).valueOf());
          if (end.diff(start, 'days') > 0) {
            self.multiDate = true;
          }
          if (self.userWorkshop.workshop_instance && self.userWorkshop.workshop_instance.recordings && self.userWorkshop.workshop_instance.recordings.length && self.userWorkshop.workshop_instance.recordings[0].link) {
            self.recordingOpts.show = true;
            self.recordingOpts.parseRecordings(self.userWorkshop.workshop_instance.recordings);
          }
        };

        $scope.$watch('item', function () {
          if ($scope.item !== undefined) {
            self.initialize();
          }
        });
      }],
      controllerAs: 'workshopDisplay'
    };
  }]);


